import type { Product } from 'apps/commerce/types.ts'
import { LegacyProduct } from 'apps/vtex/utils/types.ts'
import { toProduct } from 'apps/vtex/utils/transform.ts'
import { SlimProduct } from 'site/types.ts'

export interface VtexSimilarProduct {
    productId: string
    Cor?: string[]
    link: string
    productName: string
    items: Array<{
        Tamanho?: string[]
        images: Array<{ imageUrl: string }>
        sellers: Array<{
            commertialOffer: {
                IsAvailable: boolean
                ListPrice: number
                Price: number
            }
        }>
    }>
}

export interface SimilarProduct {
    productId: string
    color?: string
    size?: string
    url: string
    imageUrl: string
    name: string
    IsAvailable: boolean
    price: number
    listPrice: number
}

export async function useSimilars(
    product?: Pick<Product, 'inProductGroupWithID'>,
    isClient?: boolean,
) {
    const { inProductGroupWithID } = product ?? {}

    if (!inProductGroupWithID) return []

    try {
        const fetchUrl = isClient
            ? `/api/catalog_system/pub/products/crossselling/similars/${inProductGroupWithID}`
            : `https://torratorra.vtexcommercestable.com.br/api/catalog_system/pub/products/crossselling/similars/${inProductGroupWithID}`

        const rawSimilars = await fetch(
            fetchUrl,
        )

        const vtexSimilars = (await rawSimilars.json()) as VtexSimilarProduct[]

        const similars = vtexSimilars.map(
            ({ Cor, link, items, productId, productName }) => {
                const item = items[0]
                if (!link) {
                    return null
                }

                const urlObject = new URL(link)
                // Guard against legacy bad paths leaking from catalog
                if (urlObject.pathname.endsWith('/undefined')) {
                    urlObject.pathname = urlObject.pathname.replace(/\/undefined$/, '/p')
                }

                const price = Number(item.sellers[0].commertialOffer.ListPrice)
                const listPrice = Number(item.sellers[0].commertialOffer.ListPrice)

                const color = Cor?.[0]
                const size = item.Tamanho?.[0]
                const imageUrl = item.images[0].imageUrl
                const url = urlObject.pathname + urlObject.search
                const name = productName
                const IsAvailable = items.some((item) => {
                    return item.sellers.some((seller) => seller.commertialOffer.IsAvailable)
                })

                return {
                    productId,
                    color,
                    size,
                    imageUrl,
                    url,
                    name,
                    IsAvailable,
                    price,
                    listPrice,
                } as SimilarProduct
            },
        ).filter((similar): similar is SimilarProduct => similar !== null)

        const filteredSimilars = similars.reduce(
            (acc, similar) => {
                if (similar.IsAvailable) acc.push(similar)

                return acc
            },
            [] as SimilarProduct[],
        )

        const uniqueColors: Record<string, boolean> = {}

        const filteredSimilaresByColor = filteredSimilars.filter((item) => {
            if (!item.productId) return false

            if (!uniqueColors[item.productId]) {
                uniqueColors[item.productId] = true
                return true
            }
            return false
        })

        return filteredSimilaresByColor

        // return filteredSimilars
    } catch (e) {
        console.error(e)
        return []
    }
}

export async function useSimilarsFormated(product?: SlimProduct, isClient?: boolean) {
    const { inProductGroupWithID } = product ?? {}

    if (!inProductGroupWithID) return []

    try {
        const fetchUrl = isClient
            ? `/api/catalog_system/pub/products/crossselling/similars/${inProductGroupWithID}`
            : `https://torratorra.vtexcommercestable.com.br/api/catalog_system/pub/products/crossselling/similars/${inProductGroupWithID}`

        const rawSimilars = await fetch(
            fetchUrl,
        )

        const vtexSimilars = (await rawSimilars.json()) as LegacyProduct[]

        const mergedProducts = vtexSimilars.reduce((acc, product) => {
            const existingProduct = acc.find((productExist: LegacyProduct) =>
                productExist.productId === product.productId
            )
            if (existingProduct) {
                existingProduct.items.push(...product.items)
            } else {
                acc.push({ ...product })
            }
            return acc
        }, [] as LegacyProduct[])

        const sortedSimilaresByAvaiability = mergedProducts.sort((product) =>
            product.items.some((item) => item.sellers[0].commertialOffer.AvailableQuantity > 0)
                ? -1
                : 1
        )

        // const filteredSimilars = mergedProducts.filter(
        // 	(similar) => {
        // 		const items = similar.items as any

        // 		const IsAvailable = items.filter((item: any) => {
        // 			return item.sellers.some((seller: any) => seller.commertialOffer?.IsAvailable)
        // 		})

        // 		return IsAvailable
        // 	},
        // )

        // const uniqueColors: Record<string, boolean> = {}

        // const filteredSimilaresByColor = filteredSimilars.filter((item) => {
        // 	if (!item.productId) return false

        // 	if (!uniqueColors[item.productId]) {
        // 		uniqueColors[item.productId] = true
        // 		return true
        // 	}
        // 	return false
        // })

        return sortedSimilaresByAvaiability.map((legacyProduct) =>
            toProduct(legacyProduct, legacyProduct.items[0], 0, {
                baseUrl: window.location.href,
                priceCurrency: 'BRL',
            })
        )
    } catch (e) {
        console.error(e)
        return []
    }
}
